import React from "react";
import "../../assets/generalTrade.css";

const GeneralTradeContact: React.FC = () => {
  return (
    <main className="gt-page">
      <section className="gt-page-banner">
        <div className="gt-container">
          <span className="gt-eyebrow">Contact Us</span>
          <h1>Bring Quality Essentials Closer to Every Home</h1>
        </div>
      </section>

      <section className="gt-content-section">
        <div className="gt-container gt-contact-grid">
          <div className="gt-contact-card">
            <h3>Phone</h3>
            <a href="tel:+60340501142">+60 3 4050 1142</a>
          </div>
          <div className="gt-contact-card">
            <h3>WhatsApp / Mobile</h3>
            <a href="tel:+60102634462">+60 10 263 4462</a>
          </div>
          <div className="gt-contact-card">
            <h3>Email</h3>
            <a href="mailto:generaltrade@lyrazone.com.my">generaltrade@lyrazone.com.my</a>
          </div>
          <div className="gt-contact-card">
            <h3>Website</h3>
            <a href="https://www.lyrazone.com.my">www.lyrazone.com.my</a>
          </div>
          <div className="gt-contact-card gt-contact-wide">
            <h3>Address</h3>
            <p>No. 18A, Jalan Cempedak, Off Jalan Kovil Hilir, Sentul 51100, Kuala Lumpur, Malaysia.</p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default GeneralTradeContact;
